// extracted by mini-css-extract-plugin
module.exports = {"bubble":"VenueReviewTreatments-module--bubble--0a0266","showAll":"VenueReviewTreatments-module--showAll--2e686d"};